import React, { useEffect, useState } from "react";
import 'spiketip-tooltip/spiketip.min.css'
import { Link } from "react-router-dom";
import UserService from "../../services/UserService.js";
import AuthService from "../../services/AuthService.js";
import Select, { components } from "react-select";
import axios from "axios";
import { useDispatch } from "react-redux";
import getNotification from "../../Redux/Action/action.js";
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import maskedBrandOption from '../JSON Files/MaskedBrandOption.json'
import Plot from "react-plotly.js";
import Loader from "react-js-loader";
import FooterPages from '../Footer/FooterPages.jsx'
import Chart from "react-apexcharts";
import Navbar3 from "../Navbars/Navbar3.jsx";
import SubNavbar from "../Navbars/SubNavbar.jsx";
import LoaderCustom from "../LoaderCustom.jsx";
import { downloadPdf, uploadPDF } from "../HelperFunction/helperFunction.js";
import LineChartMarketAnalysis from "./LineChartMarketAnalysis.jsx";
import BarChartMarketAnalysis from "./BarChartMarketAnalysis.jsx";
const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;
// const { REACT_APP_UPLOAD_DATA } = process.env;
function MarketAnalysis() {
  const selectAllOption = { label: "Select All", value: "selectAll" };
  const [modifybtn, setmodifybtn] = useState(false)
  const [options, setoptions] = useState({})
  const [salesdata, setsalesdata] = useState([])
  const [displaynames, setdisplaynames] = useState({});
  const [currentScreen, setcurrentScreen] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [brandoptions, setbrandoptions] = useState([]);
  const [marketoptions, setmarketoptions] = useState([]);
  const [market, setmarket] = useState([]);
  const [loader, setloader] = useState(false);
  const [resultscreen, setresultscreen] = useState(false);
  const [selectedbrand, setselectedbrand] = useState("");
  const [variableslist, setvariableslist] = useState([]);
  const [variable, setvariable] = useState([]);
  const [selectedvariable, setselectedvariable] = useState("");
  const [plotdataweekly, setplotdataweekly] = useState({});
  const [plotdatamonthly, setplotdatamonthly] = useState({});
  const [statisticsdata1, setstatisticsdata1] = useState([]);
  const [corelationdata, setcorelationdata] = useState([]);
  const dispatch = useDispatch();
  const [reportName, setreportName] = useState("");
  const [subvariablesoptions, setsubvariablesoptions] = useState([])
  const [variablesoptions, setvariablesoptions] = useState([])

  useEffect(() => {
    // handledatemenu();
    handlevariablesfetch();
    // handlevariablesmenu();
  }, []);
  useEffect(() => {
    handlefetchmarket()
  }, [selectedbrand])
  useEffect(() => {
    handlefetchvariables()
  }, [market])
  const handlefetchmarket = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/get_markets`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
          setmarketoptions(
            [
              { value: "selectAll", label: "Select All" }, // Add Select All option
              ...getResponse.data.markets?.map((it) => ({
                value: it.final_market,
                label: it.final_market,
              })),
            ]
          );
        }
      } catch (err) {

      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  const handlefetchvariables = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();

        const requestData = {
          brand: selectedbrand,
          market: market,

        }

        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/get_variables`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData,
        };
        const getResponse = market?.length > 0 ? await axios(config) : [];
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
          setvariablesoptions(
            [
              // Add Select All option
              ...getResponse.data.vars_data?.filter(
                (item) => !ExceptionVariables?.zeroOrOneVariables?.includes(item.attribute_name)
              )?.map((it) => ({
                value: it.attribute_name,
                label: it.attribute_name,
              })),
            ]
          );
        }
      } catch (err) {

      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  const reverseDate = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  const scrollToSection = (sectionname) => {
    // Replace 'section2' with the id of the section you want to scroll to

    if (document.getElementById(sectionname)) {
      document
        .getElementById(sectionname)
        .scrollIntoView({ behavior: "smooth" });
    } else {
      dispatch(
        getNotification({
          message: "Please proceed with first analysis ",
          type: "Default",
        })
      );
    }
  };


  const handlevariablesfetch = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/fetchvars`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        if (getResponse.data !== "Invalid User!") {
          setStartDate(reverseDate(getResponse.data.dates[0].min[0].start_date));
          setEndDate(reverseDate(getResponse.data.dates[0].max[0].end_date));

          setbrandoptions(
            getResponse.data.brands?.filter(it => !ExceptionVariables?.brandoptionshide?.includes(it?.brand))?.map((it) => {
              return { value: it.brand, label: maskedBrandOption.maskedBrandOption[`${it.brand.trim().toUpperCase()}`] };
            })
          );

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };

  const handlecheckboxesselection = (selection) => {


    if (selection?.length > 1) {
      dispatch(getNotification({ message: "Only 1 variable allowed at one time!!", type: "danger" }))
      //document.getElementById(`${arr[0]}`).checked=false;        
      // arr.shift();
    }
    else {
      const arr = []
      selection.map((it) => {
        arr.push(it.value)
      })

      setvariable(arr);
    }

  };
  const handlebrandanalysis = async () => {
    if (UserService.isLoggedIn()) {
      if (variable && selectedbrand && startDate && endDate && market.length > 0 && selectedvariable) {
        try {

          setloader(true);
          let arr1 = []
          let arr2 = []
          if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[0].attribute_name)) {
            arr1 = ExceptionVariables.tv_Aggregated_Variables_grp
          }
          else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[1].attribute_name)) {
            arr1 = ExceptionVariables.tv_Aggregated_Variables_inr
          }
          else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[2].attribute_name)) {
            arr1 = ExceptionVariables.cp_Aggregated_Variables_inr
          }
          else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[3].attribute_name)
            || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[4].attribute_name)
            || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[5].attribute_name)) {
            selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[3].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapi[3].attribute_name)
            selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[4].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapi[4].attribute_name)
            selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapi[5].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapi[5].attribute_name)
            arr1 = selectedvariable
          }
          const requestData = {
            start_date: startDate,
            end_date: endDate,
            variables: [selectedvariable],
            brand: selectedbrand,
            market: market,
            variable_type: []
          };

          const config1 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/app/brandanalysis`,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: requestData,
          };
          const config2 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/app/monthly_brandanalysis`,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: requestData,
          };
          const getResponse1 = await axios(config1);
          const getResponse2 = await axios(config2);

          if (getResponse1.status === 200) {

            if (getResponse1.data[0] !== "Invalid User!") {

              setplotdataweekly(getResponse1.data?.market_data)
              setplotdatamonthly(getResponse2.data?.market_data)

              setresultscreen(true);
              setdisplaynames({
                ...displaynames,
                startDate: startDate,
                endDate: endDate,
                selectedbrand: selectedbrand,
                variable: selectedvariable,
                market: market,
                type: getResponse1.data[0]?.variables[0]?.units
              })
            }
            else if (getResponse1.data[0] === "Invalid User!") {
              UserService.doLogin({
                redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
              });
            }
          }
        } catch (err) {
          //handleMouseEnter();
          setresultscreen(false)
          setmodifybtn(false)
          console.log("Server Error", err);
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      } else {
        dispatch(
          getNotification({
            message: "Please fill all entries",
            type: "default",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
    setloader(false);
  };

  const fetchstatisticsdata = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const requestData = {
          // jwttoken: UserService.getToken(),
          start_date: startDate,
          end_date: endDate,
          variables: [variable],
          brand: selectedbrand,
        };

        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/statistics`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: requestData,
        };
        const getResponse = await axios(config);

        // setplot1list(Array.from(getResponse.data));
        if (getResponse.status === 200) {
          if (getResponse.data === "No Records Found." || getResponse.data === "42883: function round(real, integer) does not exist\n\nPOSITION: 25") {
            dispatch(
              getNotification({
                message: "There are no statistics record",
                type: "default",
              })
            );
          } else {

            setstatisticsdata1(getResponse.data);
          }

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  const handlesavereport = async () => {
    if (UserService.isLoggedIn()) {
      if (reportName && variable && selectedbrand && startDate && endDate) {
        try {
          setloader(true);

          const requestData = {
            report_name: reportName,
            start_date: displaynames.startDate,
            end_date: displaynames.endDate,
            brand: displaynames.selectedbrand,
            markets: displaynames.market,
            variable: displaynames.variable,
            user_created_by: UserService.getUsername(),
            created_on: new Date().toISOString().split("T")[0],
            screen: "M_A"

          };
          const config = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/app/saveMAReport`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: requestData,
          };
          const getResponse = await axios(config);

          // setplot1list(Array.from(getResponse.data));
          if (getResponse.status === 200) {
            document.getElementById("closemodal").click()
            dispatch(
              getNotification({
                message: `${getResponse?.data}`,
                type: "success",
              })
            );
          }
        } catch (err) {
          console.log("Server Error", err);
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            document.getElementById("closemodal").click()
            dispatch(
              getNotification({
                message: err.response.data,
                type: "danger",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      } else {
        dispatch(
          getNotification({
            message: "Please fill all entries",
            type: "default",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
    setloader(false);
  };
  const fetchcorelationdata = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const requestData = {
          // jwttoken: UserService.getToken(),
          start_date: startDate,
          end_date: endDate,
          variables: [selectedvariable],
          brand: selectedbrand,
        };
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/correlation`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: requestData,
        };
        const getResponse = await axios(config);
        // setplot1list(Array.from(getResponse.data));
        if (getResponse.status === 200) {
          if (getResponse.data === "No Records Found.") {
            dispatch(
              getNotification({
                message: "There are not statistics record",
                type: "default",
              })
            );
          } else {
            setcorelationdata(getResponse.data.matrix);
          }
        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };

  const [isDownloading, setIsDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  return (
    <>
      {/* save report modal */}

      <div
        class="modal "
        id="exampleModal1"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div className="modal-content" >
            <div class="modal-header" style={{ backgroundColor: "#f2f2f2" }}>
              <h6 class="modal-title" id="exampleModalLabel">
                Save Report
              </h6>
              <button
                type="button"
                class="close"
                id="closemodal"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Please enter report Name: </label>
              <input
                type="text"
                id="reportnamebox"
                className="form-control"
                value={reportName}
                onChange={(e) => setreportName(e.target.value)}
              />

              <br />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                onClick={() => {
                  if (reportName === "") {
                    document.getElementById("reportnamebox").focus();
                  } else {
                    handlesavereport();
                  }
                }}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <Navbar3 />
      <div className="bgpages">
        <div className=' mx-5'>
          <div className='breadcrumb '>{`Dashboard >> Market Analysis`}</div>
          <div className='pageheading d-flex justify-content-between align-items-center my-2 px-3 py-2' style={{ fontSize: "20px" }}>
            <b className="my-auto">Market Analysis</b>
            {resultscreen && (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-orange fw-semibold"
                  style={{ minWidth: "120px" }}
                  onClick={() => {
                    setmodifybtn(false);
                    setresultscreen(false);
                    setselectedvariable("");
                    setmarket([]);
                    setselectedbrand('');
                    setvariablesoptions([]);
                    setmarketoptions([]);
                    setDownloadUrl('')
                  }}
                  disabled={loading}
                >
                  Reset
                </button>

                <button
                  className="btn btn-info fw-semibold"
                  style={{ minWidth: "120px", color: 'black' }}
                  onClick={() => setmodifybtn(!modifybtn)}
                  disabled={loading}
                >
                  {modifybtn ? 'Close' : 'Modify'}
                </button>
              </div>
            )}

          </div>
          {
            modifybtn &&
            <div className="card p-4 shadow-sm rounded-4 border-0">
              <div className="col-sm-11 mx-auto">
                {/* First Row */}
                <div className="row g-3">
                  {/* Start Date */}
                  <div className="col-md-3 col-sm-6">
                    <label htmlFor="StartDate" className="fw-bold mb-1">
                      <strong>Start Date <span className="text-danger">*</span></strong>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="StartDate"
                      value={startDate}
                      onChange={(e) => {
                        if (endDate) {
                          if (e.target.value <= endDate) {
                            setStartDate(e.target.value);
                          } else {
                            alert("Entered start date is after end date");
                          }
                        } else {
                          setStartDate(e.target.value);
                        }
                      }}
                    />
                  </div>

                  {/* End Date */}
                  <div className="col-md-3 col-sm-6">
                    <label htmlFor="EndDate" className="fw-bold mb-1">
                      <strong>End Date <span className="text-danger">*</span></strong>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="EndDate"
                      value={endDate}
                      onChange={(e) => {
                        if (e.target.value >= startDate) {
                          setEndDate(e.target.value);
                        } else {
                          alert("Please enter End date after start date");
                        }
                      }}
                    />
                  </div>

                  {/* Brand Select */}
                  <div className="col-md-4 col-sm-6">
                    <label className="fw-bold mb-1">
                      Brand: <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="w-100"
                      placeholder="Select Brand"
                      options={brandoptions}
                      value={maskedBrandOption.maskedBrandOption[selectedbrand] ? { label: maskedBrandOption.maskedBrandOption[selectedbrand], value: selectedbrand } : null}
                      onChange={(value) => {
                        setselectedbrand(value.value);
                        setselectedvariable("");
                        setmarket([]);
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="col-md-2 col-sm-6 d-flex align-items-end">
                    <button
                      id="subm"
                      className="btn btn-dark w-100"
                      onClick={() => handlebrandanalysis()}
                    >
                      Submit
                    </button>
                  </div>
                </div>

                {/* Second Row */}
                <div className="row g-3 mt-2">
                  {/* Market Select */}
                  <div className="col-md-6 col-sm-12">
                    <label className="fw-bold mb-1">
                      <strong>Market: <span className="text-danger">*</span></strong>
                    </label>
                    <Select
                      placeholder="Select Market(s)"
                      options={marketoptions}
                      isMulti
                      value={market ? market.map((it) => ({ label: it, value: it })) : null}
                      onChange={(value) => {
                        if (value.some(item => item.value === 'selectAll')) {
                          setmarket(
                            marketoptions
                              .filter((it) => it.value !== "selectAll")
                              .map((option) => option.value)
                          );
                        } else {
                          setmarket(value.map((it) => it.value));
                        }
                        setselectedvariable("");
                      }}
                    />
                  </div>

                  {/* Marketing Inputs Select */}
                  <div className="col-md-6 col-sm-12">
                    <label className="fw-bold mb-1">
                      <strong>Marketing Inputs: <span className="text-danger">*</span>s</strong>
                    </label>
                    <Select
                      placeholder="Select Marketing Input"
                      options={variablesoptions}
                      value={selectedvariable ? { label: selectedvariable, value: selectedvariable } : null}
                      onChange={(value) => {
                        setselectedvariable(value.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          }

          <div className=" my-3 ">
            <div className=" " >
              {loader ? (
                <div
                  className="row d-flex  justify-content-center align-items-center "
                  style={{ height: "75vh" }}
                >
                  <LoaderCustom text="Fetching Market Analysis Report...." />
                </div>
              ) : resultscreen ?
                <div className="container-fluid my-3">
                  <div className="d-flex flex-column align-items-start gap-3">
                    {/* Download Button */}
                    {loading ? (
                      <button className="btn btn-secondary" disabled>
                        Preparing your Report...
                      </button>
                    ) : downloadUrl ? (
                      <button
                        className="btn btn-outline-success fw-semibold px-4 py-2 shadow-sm"
                        onClick={
                          () => {
                            setIsDownloading(true)
                            downloadPdf(downloadUrl,()=>setIsDownloading(false))
                          }
                        }
                        disabled={isDownloading}>
                        {isDownloading ? 'Dowloading....':'Download Report'}
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-primary fw-semibold px-4 py-2 shadow-sm"
                        onClick={() =>{
                          const file_name = prompt("Enter the Report Name to Genrate the Report")
                          if(file_name){
                            uploadPDF(document.getElementById("pdfConvertible"),file_name,selectedbrand, "Market_Analysis", setLoading, setDownloadUrl)
                          }
                          else{
                            alert("File Name can't be empty!!!")
                          }
                        }
                        }
                      >
                        Generate Report
                      </button>
                    )}
                    {/* PDF Content */}
                    <div id="pdfConvertible" className="w-100">
                      {resultscreen && displaynames.selectedbrand?.length > 0 && (
                        <div className="bg-white p-4 rounded-3 shadow-sm">
                          {/* Header */}
                          <h5 className="text-success fw-bold mb-3">User Selections</h5>

                          {/* User Selection Details */}
                          <div className="row g-3">
                            {/* Start Date */}
                            <div className="col-12 col-md-4">
                              <div className="border rounded-3 p-2 bg-light">
                                <strong>Start Date:</strong>
                                <div className="text-muted small">{displaynames.startDate}</div>
                              </div>
                            </div>

                            {/* End Date */}
                            <div className="col-12 col-md-4">
                              <div className="border rounded-3 p-2 bg-light">
                                <strong>End Date:</strong>
                                <div className="text-muted small">{displaynames.endDate}</div>
                              </div>
                            </div>

                            {/* Brands */}
                            <div className="col-12 col-md-4">
                              <div className="border rounded-3 p-2 bg-light">
                                <strong>Brands:</strong>
                                <div className="text-muted small">
                                  {maskedBrandOption.maskedBrandOption[selectedbrand]}
                                </div>
                              </div>
                            </div>

                            {/* Market */}
                            <div className="col-12 col-md-7">
                              <div className="border rounded-3 p-2 bg-light">
                                <strong>Market:</strong>
                                <div
                                  className="text-muted small"
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {displaynames.market?.length > 1
                                    ? displaynames.market.join(", ")
                                    : displaynames.market[0]}
                                </div>
                              </div>
                            </div>

                            {/* Marketing Inputs */}
                            <div className="col-12 col-md-5">
                              <div className="border rounded-3 p-2 bg-light">
                                <strong>Marketing Inputs:</strong>
                                <div
                                  className="text-muted small"
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {displaynames?.variable}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Chart Section */}
                      <div className="chartmarket-container mt-4">
                        <div className="chartmarket bg-white rounded-3 shadow-sm p-3">
                          {displaynames?.variable === "Sales_Volume" ||
                            displaynames?.variable === "Sales_Value" ? (
                            <LineChartMarketAnalysis
                              plotdataweekly={plotdataweekly}
                              plotdatamonthly={plotdatamonthly}
                              displaynames={displaynames}
                            />
                          ) : (
                            <BarChartMarketAnalysis
                              plotdataweekly={plotdataweekly}
                              plotdatamonthly={plotdatamonthly}
                              displaynames={displaynames}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                :
                <>
                  <div className="card p-3 shadow-sm rounded-3">
                    <div className="mx-2">
                      {brandoptions.length > 0 ? (
                        <div className="row gy-3">
                          {/* Start Date */}
                          <div className="col-md-4 col-sm-6 col-12">
                            <label htmlFor="StartDate" className="form-label">
                              <strong>Start Date</strong> <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              disabled={resultscreen}
                              className="form-control p-2"
                              id="StartDate"
                              value={startDate}
                              onChange={(e) => {
                                if (endDate) {
                                  if (e.target.value <= endDate) {
                                    setStartDate(e.target.value);
                                  } else {
                                    alert("Entered start date is after end date");
                                  }
                                } else {
                                  setStartDate(e.target.value);
                                }
                              }}
                              placeholder="Start Date"
                            />
                          </div>

                          {/* End Date */}
                          <div className="col-md-4 col-sm-6 col-12">
                            <label htmlFor="EndDate" className="form-label">
                              <strong>End Date</strong> <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              disabled={resultscreen}
                              className="form-control p-2"
                              id="EndDate"
                              placeholder="End Date"
                              value={endDate}
                              onChange={(e) => {
                                if (e.target.value >= startDate) {
                                  setEndDate(e.target.value);
                                } else {
                                  alert("Please enter End date after start date");
                                }
                              }}
                            />
                          </div>

                          {/* Brand */}
                          <div className="col-md-4 col-sm-12 col-12">
                            <label className="form-label">
                              <strong>Brand</strong> <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="w-100"
                              placeholder="Select Brand"
                              options={brandoptions}
                              value={maskedBrandOption.maskedBrandOption[selectedbrand] ? { label: maskedBrandOption.maskedBrandOption[selectedbrand], value: selectedbrand } : null}
                              onChange={(value) => {
                                setselectedvariable("");
                                setmarket([]);
                                setselectedbrand(value.value);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <p className="text-muted">
                          <div className="my-3 d-flex flex-column align-items-center justify-content-center">
                            <div className="dot-loader">
                              <div></div><div></div><div></div>
                            </div>
                            <div className="mt-2 fw-semibold text-muted">Grabbing Details...</div>
                          </div>
                        </p>
                      )}

                      {brandoptions?.length > 0 && (
                        <>
                          <div className="row gy-3 mt-2">
                            {/* Market */}
                            <div className="col-md-7 col-12">
                              <label className="form-label">
                                <strong>Market</strong> <span className="text-danger">*</span>
                              </label>
                              <Select
                                className="w-100"
                                placeholder="Select Market/Markets"
                                options={marketoptions}
                                isMulti
                                value={
                                  market
                                    ? market.map((it) => ({ label: it, value: it }))
                                    : null
                                }
                                onChange={(value) => {
                                  if (value.some((item) => item.value === "selectAll")) {
                                    setmarket(
                                      marketoptions
                                        .filter((it) => it.value !== "selectAll")
                                        .map((option) => option.value)
                                    );
                                  } else {
                                    setmarket(value.map((it) => it.value));
                                  }
                                  setselectedvariable("");
                                }}
                              />
                            </div>

                            {/* Marketing Inputs */}
                            <div className="col-md-5 col-12">
                              <label className="form-label">
                                <strong>Marketing Inputs</strong>{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                isDisabled={resultscreen}
                                className="w-100"
                                placeholder="Select Marketing Input"
                                options={variablesoptions}
                                value={
                                  selectedvariable
                                    ? { label: selectedvariable, value: selectedvariable }
                                    : null
                                }
                                onChange={(value) => {
                                  setselectedvariable(value.value);
                                }}
                              />
                            </div>
                          </div>

                          {/* Submit Button */}
                          <div className="d-flex justify-content-center mt-4">
                            <div class="submitfrmtbtn mb-2" type="button"
                              onClick={() => { handlebrandanalysis(); }}>
                              <span>Submit <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              }
            </div>
          </div>
        </div>
      </div>

      <div className='' >
        <FooterPages />
      </div>








































    </>
  );
}

export default MarketAnalysis;
